import React from 'react';

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1050
  },
  dialog: {
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '24px',
    width: '600px',
    maxHeight: '80vh',
    overflowY: 'auto',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px'
  },
  title: {
    fontSize: '24px',
    fontWeight: '600',
    margin: 0
  },
  closeButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#666',
    padding: '8px'
  },
  summaryCards: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '16px',
    marginBottom: '24px'
  },
  card: {
    padding: '20px',
    borderRadius: '8px',
    textAlign: 'center'
  },
  cardBlue: {
    backgroundColor: '#f0f7ff',
    border: '1px solid #e1effe'
  },
  cardPurple: {
    backgroundColor: '#faf5ff',
    border: '1px solid #e9d8fd'
  },
  number: {
    fontSize: '28px',
    fontWeight: 'bold',
    marginBottom: '8px'
  },
  numberBlue: {
    color: '#3182ce'
  },
  numberPurple: {
    color: '#805ad5'
  },
  label: {
    color: '#4a5568',
    fontSize: '14px'
  },
  detailsContainer: {
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    padding: '20px'
  },
  detailsTitle: {
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '16px'
  },
  dependencyItem: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr auto',
    alignItems: 'center',
    gap: '16px',
    padding: '16px 20px',
    backgroundColor: '#f8fafc',
    borderRadius: '6px',
    marginBottom: '8px',
    minHeight: '56px'
  },
  dependencyType: {
    color: '#2d3748',
    fontSize: '14px',
    fontWeight: '500',
    textAlign: 'left'
  },
  dependencyStatus: {
    color: '#4a5568',
    fontSize: '14px',
    textAlign: 'center',
    fontWeight: '400'
  },
  dependencyCount: {
    fontWeight: '600',
    color: '#3182ce',
    fontSize: '16px',
    textAlign: 'right',
    minWidth: '24px'
  },
  // Add header row styling for better organization
  dependencyHeader: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr auto',
    alignItems: 'center',
    gap: '16px',
    padding: '12px 20px',
    borderBottom: '2px solid #e2e8f0',
    marginBottom: '12px'
  },
  headerText: {
    fontSize: '12px',
    fontWeight: '600',
    color: '#718096',
    textTransform: 'uppercase',
    letterSpacing: '0.05em'
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '24px',
    paddingTop: '20px',
    borderTop: '1px solid #e2e8f0'
  },
  footerCloseButton: {
    backgroundColor: '#FFFDD0',
    color: 'black',
    border: 'none',
    borderRadius: '6px',
    padding: '10px 20px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    minWidth: '80px'
  }
};

const DependencyDialog = ({ isOpen, onClose, dependencies }) => {
  if (!isOpen) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.dialog}>
        <div style={styles.header}>
          <h2 style={styles.title}>Dependencies Overview</h2>
          <button style={styles.closeButton} onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M6 18L18 6M6 6l12 12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        <div style={styles.summaryCards}>
          <div style={{...styles.card, ...styles.cardBlue}}>
            <div style={{...styles.number, ...styles.numberBlue}}>
              {dependencies?.["Functional Levels Under This Levels"] || 0}
            </div>
            <div style={styles.label}>Child Levels</div>
          </div>

          <div style={{...styles.card, ...styles.cardPurple}}>
            <div style={{...styles.number, ...styles.numberPurple}}>
              {dependencies?.["Total Dependencies"] || 0}
            </div>
            <div style={styles.label}>Total Dependencies</div>
          </div>
        </div>

        <div style={styles.detailsContainer}>
          <h3 style={styles.detailsTitle}>Dependency Details</h3>

          {/* Optional: Add column headers */}
          <div style={styles.dependencyHeader}>
            <span style={{...styles.headerText, textAlign: 'left'}}>Type</span>
            <span style={{...styles.headerText, textAlign: 'center'}}>Status</span>
            <span style={{...styles.headerText, textAlign: 'right'}}>Count</span>
          </div>

          {dependencies?.["Other Dependencies"]?.map((dep, index) => (
            <div key={index} style={styles.dependencyItem}>
              <span style={styles.dependencyType}>
                {dep["Dependency_Type"]}
              </span>
              <span style={styles.dependencyStatus}>
                {dep["Dependency_Status"]}
              </span>
              <span style={styles.dependencyCount}>
                {dep["Dependency_Count"]}
              </span>
            </div>
          ))}
        </div>

        <div style={styles.footer}>
          <button
            style={styles.footerCloseButton}
            onClick={onClose}
            onMouseOver={(e) => e.target.style.backgroundColor = '#FFFF40'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#FFFDD0'}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default DependencyDialog;